import React, { ReactNode } from "react"
import { NoRecordsBanner } from "../OopsBanner";
import { BlogIcon, FacebookIcon, GooglePlusIcon, InstagramIcon, LinkedinIcon, PintrestIcon, MySpaceIcon, TikTokIcon, TwitterIcon, YelpIcon, YoutubeIcon, VagaroIcon, ThreadIcon } from "../Icons/SocialIcons";
import { UserContext } from "../Definitions/UserContext";

export default function RenderBusinessSocialLinks({bData,layout}:{bData:any,layout:string}){

switch(layout){

    default:
        return <RenderItems bData={bData} layout={layout} />
}

}


function RenderItems({bData,layout}:{bData:any,layout:string}){

    const isCircle = true;// layout === "1";


    if(bData?.isStenciled){
        return <div className="stenciled center-all" style={{display:"flex",gap:"inherit"}}     >
            <div className="stencil-item" style={{width:"1.8em",height:"1.8em",borderRadius:"50%"}}> </div>
            <div className="stencil-item" style={{width:"1.8em",height:"1.8em",borderRadius:"50%"}}> </div>
            <div className="stencil-item" style={{width:"1.8em",height:"1.8em",borderRadius:"50%"}}> </div>
            <div className="stencil-item" style={{width:"1.8em",height:"1.8em",borderRadius:"50%"}}> </div>
            </div>

    }

    if(!bData.Vagaro&&!bData.Blog&&!bData.Facebook&&!bData.GooglePlus&&!bData.Instagram&&!bData.Linkedin&&!bData.Pintrest&&!bData.MySpace&&!bData.TikTok&&!bData.Twitter&&!bData.Yelp&&!bData.Youtube&&!bData.Thread){
        return <NoRecordsBanner message="No Social Links Found" />
    }



    return <>

    {bData.Blog         && bData.Blog.length>0          &&  <RenderSocialItem link={bData.Blog}      id="blog"    isCircle={isCircle}      icon={<BlogIcon/>}/>}
    {bData.Facebook     && bData.Facebook.length>0      && <RenderSocialItem link={bData.Facebook}   id="facebook"  isCircle={isCircle}      icon={<FacebookIcon/>}/>}
    {bData.GooglePlus   && bData.GooglePlus.length>0    && <RenderSocialItem link={bData.GooglePlus} id="googleplus"  isCircle={isCircle}      icon={<GooglePlusIcon/>}/>}
    {bData.Instagram    && bData.Instagram.length>0     && <RenderSocialItem link={bData.Instagram}  id="instagram"  isCircle={isCircle}      icon={<InstagramIcon/>}/>}
    {bData.Linkedin     && bData.Linkedin.length>0      && <RenderSocialItem link={bData.Linkedin}   id="linkedin"  isCircle={isCircle}      icon={<LinkedinIcon/>}/>}
    {bData.Pinterest    && bData.Pinterest.length>0     && <RenderSocialItem link={bData.Pinterest}   id="pinterest"  isCircle={isCircle}      icon={<PintrestIcon/>}/>}
    {bData.MySpace      && bData.MySpace.length>0       && <RenderSocialItem link={bData.MySpace}    id="myspace"  isCircle={isCircle}      icon={<MySpaceIcon/>}/>}
    {bData.TikTok       && bData.TikTok.length>0        && <RenderSocialItem link={bData.TikTok}     id="tiktok"  isCircle={isCircle}      icon={<TikTokIcon/>}/>}
    {bData.Twitter      && bData.Twitter.length>0       && <RenderSocialItem link={bData.Twitter}    id="twitter"  isCircle={isCircle}      icon={<TwitterIcon/>}/>}
    {bData.Yelp         && bData.Yelp.length>0          && <RenderSocialItem link={bData.Yelp}       id="yelp"  isCircle={isCircle}      icon={<YelpIcon/>}/>}
    {bData.Youtube      && bData.Youtube.length>0       && <RenderSocialItem link={bData.Youtube}    id="youtube"  isCircle={isCircle}      icon={<YoutubeIcon/>}/>}
    {bData.Thread       && bData.Thread.length>0        &&<RenderSocialItem link={bData.Thread}      id="thread"  isCircle={isCircle}      icon={<ThreadIcon/>}/>}
    {bData.Vagaro       && bData.Vagaro.length>0        &&<RenderSocialItem link={bData.Vagaro}      id="vagaro"  isCircle={isCircle}      icon={<VagaroIcon/>}/>}

    </>

}









function RenderSocialItem({link,icon,isCircle,id}:{link:string,icon:ReactNode,isCircle:boolean,id:string}): JSX.Element {



    if(!link.includes("http")){

        if(!link.includes("www.")){
            link = "www."+link;
        }

        link = "https://"+link;
    }


return <div className={"center-all social-icon "+id} style={{width:"1.8em",height:"1.8em",borderRadius:"100%",padding:".4em",background:"transparent"}}>
    <a className="center-all max-100 " target="_blank" href = {link}  style={{color:"inherit"}} >
       {icon}
    </a>
</div>

}
